/*
poornima 9/19/2022  2700912712  Fixed GAL- 122,127,128,130,161,163,170,171,173 bugs
ashraf  10/13/2022  2701127043_2698966688  fixed filter and formula rule group, communication history bug fixes
Suresh Peddavoora  10/26/2022 2701127043_2698966688 Changed textfield variant from outlined to standard .
Rohini 11/01/2022 2701127043_2698966688  added condition for the helper text
sai krishna 11/03/2022 2701127043 Changed label names
Prakash 11/03/2022  2701127043_2698966688 Added classes for text fields.
saikrishna 11/04/2022 2701127043 Added props
Dilip 11/04/2022 2701012930 Changed state for open delete popup
Sohel 11/08/2022 2701127043 prepopulate formula code
Dilip 11/07/2022 2701012930  Enable delete usage popup
Akhila 11/21/2022 2701127043 addAccount props pass
Sohel 11/21/2022 2701127043 pass props
Suresh Peddavoora 11/22/2022 2701127043 - Fixed Spacing Alignments for Buttons.
Prakash 11/22/2022 2701127043 Added conditional card spacing.
Ashraf 11/22/2022 2701127043 Added formula type, status fields in search.
Sohel 11/22/2022 2701012930 formula Rule Group Table changes
Sohel 11/22/2022 2701012930 formula Rule Group Table set return Type values
Ashraf 11/23/2022 2701012930 prepopulation of search rule form for add actions in triggers
Ashraf 11/23/2022 2701012930 fixed resetting search form
Prakash 11/23/2022  2701012930  Fixed Responsiveness.
lalitha 12/07/2022 2701012930 added Created By field
Poornima 12/08/2022 2701012930 Added download usage and configuration buttons
Prakash 12/08/2022  2701012930 Fixed Fields ,Table, Buttons Responsiveness and Alignments.
Lalitha 12/08/2022 2701012930 Rename Formula to Data Calculation
Saikrishna 12/08/2022 2698948956 Removed name fields.
Akhila 12/09/2022 2701012930 fixed session saerch issue
lalitha 12/09/2022 2698948956 Added Created Date Field
akhila 12/12/2022 2701012930 changed Data calculation type options
Rohini 12/16/2022 2701012930 Fixed Buttons Alignment issue in Responsive
Ashraf 15/16/2022 2701012930 fixed role access
Raghu 17/12/2022 2701012930 Data Calculations popup fields alignment fixes
dilip 20/12/2022 2701012930 Added return type data from API.
akhila 12/21/2022 2701012930 integrated lookup api for returnType dropDown
akhila 12/21/2022 2701012930 fixed underscore issue
Ashraf 01/02/2022 3225736869 fixed white space validation issue
Akhila 02/01/2023 3225736869 bugFixed for trigger addAction prepopulation issue of return type
Dilip 02/09/2023 3225736869 added created by dropdown
Raghu 02/21/2023 3225736869 changed text feilds colors
Raghu 02/23/2023 3225736869 fixed new ui changes
Raghu 02/27/2023 3225736869 fixed new alignments
Raghu 02/28/2023 3225736869 fixed new alignments
Rohini 03/03/2023 3225736869 fixed the alignment issues
suresh peddavoora 04/06/2023 3225736869 field alignments fixes
Prakash 20/04/2023 3225736869 fixed alignment issue for input filed in tab view
Sohel  04/25/2023 2701127043 Added Data Calculation Field
Prakash 24/04/2023 3225736869 fixed alignment issue for input filed in 1024 screens
Prakash 04/26/2023 3225736869 fixed issue in tab view
Prakash 10-05-23 3225736869 fixed alignment issue in tab view.
Sohel 05/26/2023 3225736869 Added Created Date Validation
Akhila 06/08/2023 2698948956 created date change to date created field and column
Ravi  06/08/2023 2698948956  rearrange search fields
Prakash 13-06-2023 3031450488 fixed alignments issues
Akhila 06/20/2023 3031450488 bug fix filter Value field
Sohel 11/30/2023 3031450488 fixed Data Calculation Usage Popup up Reset Issue 
*/
import React, {useState, useContext, useEffect, useRef} from 'react';
import {Form, Formik} from 'formik';
import {Button, TextField, FormHelperText} from '@material-ui/core';
import ErrorBoundaryForComponents from '../../../../../util/ErrorBoundaryForComponents';
import {useSelector} from 'react-redux';
import PageLoader from '../../../../../components/PageLoader';
import {
  SuccessSnackbar,
  ErrorSnackbar,
  WarningSnackbar,
} from '../../../../../components/CustomSnackBar';
import RuleGroupSearchTable from './RuleGroupSearchTable';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import * as Yup from 'yup';
import {
  getAllReportCreatedForData,
  fetchCreatedByDropDownData,
} from '../../../../../redux/reducers/ReportMaster';
import {useDispatch} from 'react-redux';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
import {getDataCalculationData} from '../../../../../redux/reducers/GlobalField/AddFieldList';
import {getOptions} from '../../../../../util/GetDropDownOptions';
import {RETURN_TYPE} from '../../../../../constants/Lookup';
import {filteredCheckedData, tempSelectFunc} from '../../../../../util/Functions';
import {createdByOptions} from '../../../../../util/CreatedByForOptions';

const RuleGroupSearch = ({
  card,
  setValue,
  setFieldRowData,
  setSearchData,
  searchData,
  setSelectedRows,
  selectedRows,
  setBreCode,
  setResetData,
  dataReset,
  handleClose,
  setUsageState,
  usageState,
  setRowSelected,
  addAccount,
  setOpenFormulaCode,
  setSelectedFormulaCode,
  addAction,
  fieldRowData,
  setEditExisting,
  isReports,
  mapFields,
  setTempSelectedRows,
  tempSelectedRows,
  handleDataCalculationFields,
  setReportSelectedRows,
  setReportFieldValue,
  reportFieldsDeleteIdsRef,
  workqueueFieldsDeletedIdsRef,
  isWorkQueue,
  reportSelectedRows,
  isReportsFilter,
  rules,
  setRules,
  setInitialValues,
  filterValues,
  filterMethodRef,
  resultExpCondition,
  dialog,
  handleFilterClose = () => { },
  addAccountUpdate,
  selectedGlobalField,
}) => {
  const StatusOptions = [
    {key: 'Y', value: 'Draft'},
    {key: 'N', value: 'Completed'},
  ];

  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [searchFlag, setSearchFlag] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [customError, setCustomError] = useState(false);
  const [deleteUsage, setDeleteUsage] = useState(false);
  const [userMetrixDelete, setUserMetrixDelete] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isUsage, setIsUsage] = useState(false);
  const tempUnCheckedRef = useRef([]);
  const {isLoading, successMsg, errorMsg, formulaUsageResponse} = useSelector(
    ({addRuleGroup}) => addRuleGroup,
  );
  const {userDefinedFieldsData} = useSelector(({addEventTactic}) => addEventTactic);
  const {dropDownData} = useSelector(({addFieldList}) => addFieldList);
  const dispatch = useDispatch();
  const {createdByData} = useSelector(({reportMaster}) => reportMaster);
  const {searchRuleGroupFieldData} = useSelector(({addEventTactic}) => addEventTactic);
  const schema = Yup.object().shape({
    createdDate: Yup.date().typeError('Invalid date format').nullable(),
  });
  useEffect(() => {
    if (formulaUsageResponse?.userMetrix === 'No') {
      deleteUsage ? setUserMetrixDelete(false) : setCustomError(true);
      deleteUsage && setIsDelete(true);
      setTimeout(() => {
        setCustomError(false);
      }, 3000);
    } else if (formulaUsageResponse?.userMetrix === 'Yes') {
      deleteUsage && setIsDelete(true);
      deleteUsage && setUserMetrixDelete(true);
      !deleteUsage && setUsageState(true);
      !deleteUsage && setValue(2);
    }
  }, [formulaUsageResponse]);
  const getObject = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item?.fieldName === option) {
          label = item;
        }
      });
    return label;
  };
  useEffect(() => {
    dispatch(fetchCreatedByDropDownData('datacalculation'));
  }, [dispatch]);

  useEffect(() => {
    if (!addAccount && !isReports) {
      setUsageState(false);
      setValue(0);
      setIsDelete(false);
      setCustomError(false);
      setRowSelected(false);
    }
  }, []);

  useEffect(() => {
    dispatch(getDataCalculationData());
  }, []);

  const handleSubmit = (data) => {
    setSearchFlag(true);
    setSearchData(data);
    setSubmit(true);
    if (!addAction && !isReports && !isReportsFilter) {
      sessionStorage.setItem('DataCalculations', JSON.stringify(data));
    }
  };

  const SearchSessionDataCalculations = JSON.parse(sessionStorage.getItem('DataCalculations'));
  const getObjects = (option, typeCode) => {
    const options = dropDownData && dropDownData[typeCode] ? dropDownData[typeCode] : [];
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item?.valueCode === option) {
          label = item;
        }
      });
    return label;
  };
  const initialValues = {
    category: '',
    displayName: '',
    globalField: '',
    description: '',
    tableName: '',
    tableField: '',
    fieldType: '',
    code: '',
    formulaType: '',
    returnType:
      addAction && searchRuleGroupFieldData?.returnType ?
        getObjects(searchRuleGroupFieldData?.returnType, RETURN_TYPE, dropDownData) :
        addAccountUpdate ?
          getObjects(selectedGlobalField?.fieldType, RETURN_TYPE, dropDownData) :
          '',
    status: addAction || addAccount || isReports ? {key: 'N', value: 'Completed'} : '',
    createdBy: '',
    createdDate: null,
  };
  const formulaTypeOptions = [
    {key: 'Create Constant', value: 'Create Constant'},
    {
      key: 'Calculate based on Data Repository Fields',
      value: 'Calculate based on Data Repository Fields',
    },
  ];

  useEffect(() => {
    if (addAction || addAccount || addAccountUpdate) {
      const data = {
        ...searchData,
        returnType:
          addAction && searchRuleGroupFieldData?.returnType ?
            searchRuleGroupFieldData?.returnType :
            addAccountUpdate ?
              selectedGlobalField?.fieldType :
              '',
        status: addAction || addAccount ? {key: 'N', value: 'Completed'} : '',
      };
      setSearchData(data);
    }
  }, []);

  const onClear = () => {
    const data = {
      category: '',
      displayName: '',
      globalField: '',
      description: '',
      tableName: '',
      tableField: '',
      fieldType: '',
      code: '',
      formulaType: '',
      returnType:
        addAction && searchRuleGroupFieldData?.returnType ?
          searchRuleGroupFieldData?.returnType :
          '',
      status: addAction || addAccount || isReports ? {key: 'N', value: 'Completed'} : '',
      createdBy: '',
      createdDate: null,
    };
    setSearchData(data);
  };
  useEffect(() => {
    dispatch(getAllReportCreatedForData());
    if(setCustomError) {
      setCustomError(false);
    } 
  }, []);
  return (
    <div className={card && !dialog ? `col-12 hello` : `col-12`}>
      <h2 className="search-title">Data Calculation Search</h2>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={
          SearchSessionDataCalculations && !addAction && !isReports && !isReportsFilter ?
            SearchSessionDataCalculations :
            initialValues
        }
        validationSchema={schema}
        enableReinitialize
      >
        {(props) => {
          const {touched, values, setFieldValue, handleChange, handleReset, handleBlur, errors} =
            props;
          return (
            <div>
              <Form autoComplete="off" noValidate>
                <div>
                  <ErrorBoundaryForComponents>
                    <div className="form-row  standard-field-textfields new-standard-textfields">
                      <div
                        className={
                          card ?
                            `col-sm-2 col-md-4 col-lg-4 ${
                                errors?.code?.length > 30 ? 'adduser-password-fields' : 'form-group'
                            }` :
                            `col-sm-6 col-md-4 col-lg-4 ${
                                errors?.code?.length > 30 ? 'adduser-password-fields' : 'form-group'
                            }`
                        }
                      >
                        <TextField
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Data Calculation Name`}
                          label="Data Calculation Name"
                          className={` ${classes.labelName}`}
                          name="code"
                          value={values?.code}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                          touched={touched.code}
                        />
                      </div>
                      {/* <div className={card ? `col-sm-4 form-group` : `col-sm-6 col-md-4 col-lg-4 col-xl-2 form-group`}>
                        <TextField
                          margin="dense"
                          variant="standard"
                          placeholder={`Enter Data Calculation Name`}
                          label="Data Calculation Name"
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          name="displayName"
                          value={values.displayName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                        />
                      </div> */}
                      <div
                        className={
                          card ?
                            `col-sm-3 col-md-4 col-lg-4 form-group` :
                            `col-sm-6 col-md-4 col-lg-4 form-group account-number-textfield`
                        }
                      >
                        <TextField
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Data Calculation Description`}
                          label="Data Calculation Description"
                          className={` ${classes.labelName}`}
                          name="description"
                          value={values.description}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                        />
                      </div>
                      <div
                        className={
                          card ?
                            `col-sm-3 col-md-4 col-lg-4 form-group` :
                            'col-sm-6 col-md-4 col-lg-4 form-group'
                        }
                      >
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="formulaType"
                          id="formulaType"
                          size="small"
                          value={values.formulaType}
                          options={formulaTypeOptions}
                          getOptionLabel={(option) => {
                            return option && option.value ? option?.value : '';
                          }}
                          onChange={(e, value) => {
                            handleChange(e);
                            setFieldValue('formulaType', value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                {...params}
                                className={` ${classes.labelName}`}
                                error={Boolean(touched.formulaType && errors.formulaType)}
                                variant="outlined"
                                margin="dense"
                                label="Data Calculation Type"
                                placeholder="Select Data Calculation Type"
                              />
                              <FormHelperText variant="outlined">
                                {touched.formulaType && errors.formulaType}
                              </FormHelperText>
                            </div>
                          )}
                        />
                      </div>
                      <div
                        className={
                          card ?
                            `col-sm-2 col-md-3 col-lg-2 form-group` :
                            `col-sm-6 col-md-3 col-lg-2 form-group`
                        }
                      >
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          {...props}
                          id="returnType"
                          size="small"
                          disabled={
                            Boolean(addAction && searchRuleGroupFieldData?.returnType) ||
                            addAccountUpdate
                          }
                          value={values.returnType}
                          options={getOptions(RETURN_TYPE, dropDownData)}
                          getOptionLabel={(option) => {
                            return option && option?.valueCode ? option?.valueCode : '';
                          }}
                          onChange={(_, data) => {
                            setFieldValue('returnType', data);
                          }}
                          autoHighlight
                          renderInput={(params) => (
                            <GuiTextField
                              className={` ${classes.labelName}`}
                              {...params}
                              variant="outlined"
                              margin="dense"
                              fullWidth
                              label="Return Type"
                              name="returnType"
                              error={errors.returnType}
                              placeholder="Select Return Type"
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: 'off',
                              }}
                            />
                          )}
                        />
                      </div>
                      <div className="col-sm-6 col-md-3 col-lg-2 form-group start-enddate">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="createdBy"
                          id="createdBy"
                          size="small"
                          value={values.createdBy}
                          options={createdByData}
                          getOptionLabel={(option) => {
                            return option && option?.userLoginName ? option?.userLoginName : '';
                          }}
                          onChange={(e, value) => {
                            setFieldValue('createdBy', value);
                          }}
                          renderOption={(option) => {
                            return createdByOptions(option);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                {...params}
                                className={` ${classes.labelName}`}
                                variant="outlined"
                                margin="dense"
                                label="Created By"
                                placeholder="Select Created By"
                              />
                            </div>
                          )}
                        />
                      </div>
                      <div
                        className={
                          card ?
                            `col-sm-6 col-md-3 col-lg-3 form-group start-enddate` :
                            `col-sm-6 col-md-3 col-lg-2 form-group start-enddate`
                        }
                      >
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            className={` ${classes.labelName}`}
                            format="MM/dd/yyyy"
                            placeholder="MM/DD/YYYY"
                            fullWidth
                            value={values.createdDate}
                            name="createdDate"
                            onBlur={handleBlur}
                            inputVariant="outlined"
                            helperText=""
                            label="Date Created"
                            onChange={(val) => {
                              setFieldValue('createdDate', val);
                            }}
                            autoOk
                            margin="dense"
                            touched={touched?.createdDate}
                            error={Boolean(touched?.createdDate && errors?.createdDate)}
                          />
                        </MuiPickersUtilsProvider>
                        <FormHelperText variant="outlined">
                          {touched.createdDate && errors.createdDate ? errors.createdDate : ''}
                        </FormHelperText>
                      </div>
                      <div
                        className={
                          card ?
                            `col-sm-2 col-md-3 col-lg-2 form-group` :
                            'col-xs-4 col-sm-6 col-md-3 col-lg-2 form-group'
                        }
                      >
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="status"
                          id="status"
                          size="small"
                          options={StatusOptions}
                          disabled={addAction || addAccount || isReports}
                          value={values.status}
                          getOptionLabel={(option) => {
                            return option && option?.value;
                          }}
                          onChange={(e, value) => {
                            handleChange(e);
                            setFieldValue('status', value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                {...params}
                                className={` ${classes.labelName}`}
                                variant="outlined"
                                margin="dense"
                                // InputLabelProps={{ shrink: true }}
                                label="Status"
                                placeholder="Select Status"
                              />
                            </div>
                          )}
                        />
                      </div>
                      {/* <div className={`col-sm-6 col-md-12 col-lg-4 form-group`}>
                        <div
                          className={"d-flex justify-content-md-center justify-content-lg-start"}
                        >
                          <Button
                            variant="outlined"
                            className={`reset-btn mx-1 ${classes.buttonRoot}`}
                            onClick={() => {
                              handleReset();
                              setSearchData({});
                              setSubmit(true);
                              onClear();
                              sessionStorage.removeItem("DataCalculations");
                            }}
                          >
                            Reset
                          </Button>
                          <Button
                            variant="outlined"
                            type="submit"
                            className={`search-btn mx-1 ${classes.buttonRoot}`}
                          >
                            Search
                          </Button>
                        </div>
                      </div> */}
                      {!mapFields ? (
                        <div
                          className={
                            isReports ?
                              'col-md-4 col-lg-12 col-xl-12 form-group' :
                              'col-md-12 col-lg-3 col-xl-3 form-group'
                          }
                        >
                          <div
                            className={
                              isReports ?
                                'd-flex justify-content-xl-center justify-content-lg-center justify-content-md-center' :
                                'd-flex justify-content-xl-start justify-content-lg-center justify-content-md-center'
                            }
                          >
                            <Button
                              variant="outlined"
                              className={`mr-1 reset-btn ${classes.buttonRoot}`}
                              onClick={() => {
                                handleReset();
                                setSearchData({});
                                setSubmit(true);
                                onClear();
                                sessionStorage.removeItem('DataCalculations');
                              }}
                            >
                              Reset
                            </Button>
                            <Button
                              type="submit"
                              variant="outlined"
                              className={`ml-1 search-btn ${classes.buttonRoot}`}
                            >
                              Search
                            </Button>
                          </div>
                        </div>
                      ) : null}
                    </div>
                    {mapFields ? (
                      <div className="form-row new-standard-textfields">
                        <div className="col-md-7 col-lg-7 col-xl-7 mb-3">
                          <div className="d-flex  justify-content-end">
                            <Button
                              variant="outlined"
                              className={`mr-1 reset-btn ${classes.buttonRoot}`}
                              onClick={() => {
                                handleReset();
                                setSearchData({});
                                setSubmit(true);
                                onClear();
                                sessionStorage.removeItem('DataCalculations');
                              }}
                            >
                              Reset
                            </Button>
                            <Button
                              type="submit"
                              variant="outlined"
                              className={`ml-1 search-btn ${classes.buttonRoot}`}
                            >
                              Search
                            </Button>
                          </div>
                        </div>
                        <div className={`col-md-5 col-lg-5 col-xl-5 mb-3`}>
                          <div className="d-flex justify-content-xl-end justify-content-lg-end justify-content-md-end">
                            <Button
                              aria-label="close"
                              variant="outlined"
                              className={`mr-1 reset-btn ${classes.buttonRoot}`}
                              onClick={() => {
                                handleDataCalculationFields();
                              }}
                            >
                              Close
                            </Button>
                            <Button
                              aria-label="save"
                              variant="outlined"
                              className={`ml-1 search-btn ${classes.buttonRoot}`}
                              onClick={() => {
                                const obj = tempSelectFunc(
                                  'repositoryName',
                                  'fieldName',
                                  tempUnCheckedRef,
                                );
                                if (setReportSelectedRows) {
                                  const [newSelectedRows, newUnSelectedRows] = filteredCheckedData(
                                    reportSelectedRows,
                                    obj,
                                    'repositoryName',
                                    'fieldName',
                                  );

                                  tempSelectedRows.forEach((el) => {
                                    setReportFieldValue(
                                      'fieldHeader' + el.fieldName + el.repositoryName,
                                      el.fieldLabel,
                                    );
                                    setReportFieldValue(
                                      'printSubTotal' + el.fieldName + el.repositoryName,
                                      'N',
                                    );
                                  });
                                  if (!isWorkQueue) {
                                    reportFieldsDeleteIdsRef.current = [
                                      ...reportFieldsDeleteIdsRef.current,
                                      newUnSelectedRows?.length > 0 ?
                                        newUnSelectedRows[0]?.reportFieldId :
                                        0,
                                    ];
                                  }
                                  if (isWorkQueue) {
                                    workqueueFieldsDeletedIdsRef.current = [
                                      ...workqueueFieldsDeletedIdsRef.current,
                                      newUnSelectedRows?.length > 0 ?
                                        newUnSelectedRows[0]?.workqueueFieldId :
                                        0,
                                    ];
                                  }


                                  const allSelectedRows = [...newSelectedRows, ...tempSelectedRows];

                                  setReportSelectedRows(allSelectedRows);
                                }
                                if (setRules) {
                                  const newArr = [];

                                  tempSelectedRows.forEach((row, i) => {
                                    const obj = {
                                      field: {
                                        ...row,
                                        dataType: row.fieldType,
                                        globalField: row.fieldName,
                                      },
                                      condition: '',
                                      value: '',
                                      sqlValue: '',
                                      value1: '',
                                      ruleCode: '',
                                      ...row,
                                    };
                                    if (rules?.length === 0) {
                                      obj.ruleCode =  'S' + (i + 1);
                                    } else {
                                      const lastRuleCodeNum = Number(rules[rules?.length - 1].ruleCode.slice(1));
                                      obj.ruleCode = 'S' + (lastRuleCodeNum + i + 1);
                                    }
                                    // obj.ruleCode =
                                    //   copyArr.length > 0
                                    //     ? "S" +
                                    //       (Number(copyArr[copyArr.length - 1].ruleCode.slice(1)) + 1)
                                    //     : "S1";
                                    newArr.push(obj);
                                  });

                                  //             obj.ruleCode =
                                  //   copyArr.length > 0
                                  //     ? "S" + (Number(copyArr[copyArr.length - 1].ruleCode.slice(1)) + 1)
                                  //     : "S1";
                                  // copyArr.push(obj);

                                  if (newArr.length > 0) {
                                    const result = [...rules, ...newArr].map(
                                      (el, i) => el.ruleCode,
                                    );
                                    setFieldValue(
                                      'sqlExpression',
                                      result.join(` ${resultExpCondition} `),
                                    );

                                    setInitialValues((prev) => {
                                      return {
                                        ...prev,
                                        sqlRules: [...rules, ...newArr],
                                        sqlExpression: result.join(` ${resultExpCondition} `),
                                        accessMethod: filterMethodRef.current ?
                                          filterMethodRef.current :
                                          '',
                                        disposition: filterValues?.disposition ?
                                          filterValues?.disposition :
                                          [],
                                        collectors: filterValues?.collectors ?
                                          filterValues?.collectors :
                                          [],
                                        repoitoryName: filterValues?.repoitoryName ?
                                          filterValues?.repoitoryName :
                                          '',
                                        fieldsName: filterValues?.fieldsName ?
                                          getObject(
                                            filterValues?.fieldsName?.fieldName,
                                            userDefinedFieldsData,
                                          ) :
                                          '',
                                        values: filterValues?.values ? filterValues?.values : [],
                                        client: filterValues?.client ? filterValues?.client : [],
                                        phase: filterValues?.phase ? filterValues?.phase : [],
                                        Date: filterValues?.Date ? filterValues?.Date : '',
                                        lastDate: filterValues?.lastDate ?
                                          filterValues?.lastDate :
                                          '',
                                        startDate: filterValues?.startDate ?
                                          filterValues?.startDate :
                                          '',
                                        action: filterValues?.action ? filterValues?.action : '',
                                        fromValues: filterValues?.fromValues ?
                                          filterValues?.fromValues :
                                          '',
                                        toValues: filterValues?.toValues ?
                                          filterValues?.toValues :
                                          '',
                                      };
                                    });
                                  }
                                }
                                setTempSelectedRows([]);
                                handleDataCalculationFields();
                                handleFilterClose();
                              }}
                            >
                              Save
                            </Button>
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </ErrorBoundaryForComponents>
                </div>
              </Form>
              {isLoading && <PageLoader />}
              {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
              {successMsg && <SuccessSnackbar successMsg={successMsg} />}
            </div>
          );
        }}
      </Formik>
      <RuleGroupSearchTable
        setResetData={setResetData}
        setValue={setValue}
        setFieldRowData={setFieldRowData}
        searchData={searchData}
        setSelectedRows={setSelectedRows}
        selectedRows={selectedRows}
        searchFlag={searchFlag}
        setBreCode={setBreCode}
        submit={submit}
        setSubmit={setSubmit}
        dataReset={dataReset}
        handleClose={handleClose}
        setUsageState={setUsageState}
        usageState={usageState}
        setDeleteUsage={setDeleteUsage}
        userMetrixDelete={userMetrixDelete}
        deleteUsage={deleteUsage}
        isDelete={isDelete}
        setIsDelete={setIsDelete}
        isUsage={isUsage}
        setIsUsage={setIsUsage}
        setRowSelected={setRowSelected}
        setUserMetrixDelete={setUserMetrixDelete}
        addAccount={addAccount}
        setOpenFormulaCode={setOpenFormulaCode}
        setSelectedFormulaCode={setSelectedFormulaCode}
        addAction={addAction}
        fieldRowData={fieldRowData}
        setEditExisting={setEditExisting}
        isReports={isReports}
        setTempSelectedRows={setTempSelectedRows}
        tempSelectedRows={tempSelectedRows}
        setReportFieldValue={setReportFieldValue}
        reportSelectedRows={reportSelectedRows}
        setReportSelectedRows={setReportSelectedRows}
        tempUnCheckedRef={tempUnCheckedRef}
        isReportsFilter={isReportsFilter}
        rules={rules}
        setRules={setRules}
        setInitialValues={setInitialValues}
        filterValues={filterValues}
        filterMethodRef={filterMethodRef}
        resultExpCondition={resultExpCondition}
        handleFilterClose={handleFilterClose}
        addAccountUpdate= {addAccountUpdate}
        selectedGlobalField= {selectedGlobalField}
      />
      {customError && <WarningSnackbar errorMsg={'This Data Calculation is not being anywhere'} />}
    </div>
  );
};

export default RuleGroupSearch;
